import React, { useEffect, useState } from 'react';
import { Input, Option, Rule } from '../../../../store/modules/rules';
import { useActions } from '../../../providers/actions-provider/actions.context';
import getRuleFieldValue from './utils/getRuleFieldValue';
import StatementInput from './statement.input';

type IInputsProps = {
  rule: Rule;
  inputs: Input[] | undefined;
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input) => void,
};

const SetInputs = ({
  rule, inputs, onChange,
}: IInputsProps): JSX.Element | null => {
  const [selectedProperty, setSelectedProperty] = useState<string>(getRuleFieldValue<string>(rule, 'property') || '');
  const [input, setInput] = useState<Input | null>(null);
  const { ruleActions } = useActions();

  const firstInput = inputs && inputs[0];

  useEffect(() => {
    if (inputs && inputs[1]['options.src']) {
      if (selectedProperty && firstInput) {
        // if there is a selected property then we can get the option that is
        const selectedOption = firstInput.options
          && firstInput.options.find((o: Option) => o.value === selectedProperty);
        if (selectedOption && selectedOption.url) {
          ruleActions
            .getSetPropertyInput(selectedOption.url)
            .then((inputResult) => setInput(inputResult));
        }
      }
    }
  }, [selectedProperty]);

  if (!inputs) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: '10px' }}>
      <>
        {firstInput && (
          <StatementInput
            rule={rule}
            input={firstInput}
            onChange={(v: string) => {
              onChange(v, rule, firstInput);
              if (input) {
                onChange('', rule, input);
              }
              setSelectedProperty(v);
            }}
          />
        )}
      </>
      <>
        {input && (<StatementInput rule={rule} input={input} onChange={onChange} />)}
      </>
    </div>
  );
};

export default SetInputs;
